module.exports = __webpack_public_path__ + "static/media/Settings.6b7a65f4.svg";